import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/App';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import { userActionTypes } from './actions/types';
import { setAuthTokenRefreshListener } from './utils/authTokenSync';
import './i18n';
import './assets/fonts/vazir.css';
import './assets/fonts/arshia.css';
import './assets/styles/style.css';

// Generate global key for entities
let key = 0;
window.$_getEntityKey = () => {
  return key++;
};

if (process.env.NODE_ENV !== 'development') console.log = () => {};

// if (dir === 'ltr') {
//   require('./assets/styles/styleLTR.scss');
// } else {
//   require('./assets/styles/styleRTL.scss');
// }

document.documentElement.dataset.theme = 'dark';

// Configure redux store
const preloadedState = {};
const store = configureStore(preloadedState);
setAuthTokenRefreshListener(authToken => {
  store.dispatch({ type: userActionTypes.TOKEN_REFRESHED, authToken });
});

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root'),
);

// Remove registrations from older releases without bundling the CRA service-worker helper.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .getRegistrations()
      .then(registrations => registrations.forEach(registration => registration.unregister()));
  });
}
